<template>
  <section class="cta-section">
    <div class="cta-inner">
      <div class="cta-banner">
        <div class="cta-left">
          <div class="cta-eyebrow">{{ t('cta.eyebrow') }}</div>
          <div class="cta-title">{{ t('cta.title') }}</div>
          <div class="cta-sub">{{ t('cta.sub') }}</div>
        </div>
        <div class="cta-right">
          <button class="btn-cta" @click="emit('getReport')">
            {{ t('cta.button') }}
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
              <path d="M2 7h10M8 3l4 4-4 4" stroke="#0d0f0d" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <div class="cta-note">{{ t('cta.note') }}</div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const emit = defineEmits<{ getReport: [] }>();
</script>
